export enum ContextState {
    NoChange = 1,
    ContextRemoved = 2,
    IssueRemoved = 3,
  }
